import { Injectable, OnDestroy } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { Subject, filter, takeUntil } from 'rxjs';
import { CommonService } from './common.service';
import { GlobalService } from './global.service';

/**
 * Serviço responsável por registar logs de navegação de forma assíncrona.
 *
 * Anteriormente, o log era feito dentro do authGuard, o que atrasava
 * cada transição de rota (o Angular processava o Observable do HTTP POST
 * antes de completar a ativação da rota).
 *
 * Agora, o log é feito APÓS a navegação completar (NavigationEnd),
 * garantindo que a transição é instantânea e fluida.
 */
@Injectable({ providedIn: 'root' })
export class NavigationLoggerService implements OnDestroy {
  private destroy$ = new Subject<void>();

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private commonService: CommonService,
    private globalService: GlobalService,
  ) {
    this.router.events
      .pipe(
        filter(e => e instanceof NavigationEnd),
        takeUntil(this.destroy$),
      )
      .subscribe((event: NavigationEnd) => {
        this.logNavigation(event.urlAfterRedirects);
      });
  }

  /**
   * Regista a navegação de forma fire-and-forget.
   * Extrai o breadcrumb da rota ativa mais profunda para manter
   * compatibilidade com os logs existentes.
   */
  private logNavigation(url: string): void {
    const user = this.globalService.loggedUserClass;
    if (!user?.idUser || !user?.UUID) return;

    // Extrair breadcrumb da rota ativa mais profunda
    let child = this.activatedRoute.firstChild;
    while (child?.firstChild) {
      child = child.firstChild;
    }
    const breadcrumb = child?.snapshot?.data?.['breadcrumb'] || '';
    if (!breadcrumb) return;

    // Fire-and-forget — completamente fora do ciclo de navegação
    this.commonService.SetSiteRoutesLog(user.idUser, breadcrumb, url, user.UUID).subscribe({ error: () => {} });
  }

  ngOnDestroy(): void {
    if (!this.destroy$.closed) {
      this.destroy$.next();
      this.destroy$.complete();
    }
  }
}
